<template>
  <div class="write-about-us">
    <h2 class="write-about-us-title">{{ title }}</h2>
    <div class="write-about-us-block">
      <DefSlider :settings="settings" :nav="false" :pagination="false" :priority="true">
        <div v-for="item in countries" :key="item.ID" class="swiper-slide">
          {{ item?.UF_NAME }}
        </div>
      </DefSlider>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import { Autoplay } from 'swiper/modules';
import type { SwiperOptions } from 'swiper/types';
import { useResultsStore } from '@/storePinia/stores/results';

const resultsStore = useResultsStore();

const title = computed(() => resultsStore.messages?.sovaRightWhereAreYou);
const countries = computed(() => resultsStore.deliveryCountries?.items);

const settings: SwiperOptions = {
  slidesPerView: 'auto',
  modules: [Autoplay],
  autoplay: {
    delay: 5000,
  },
  loop: true,
  // breakpoints: {
  //   768: {
  //     slidesPerView: 4.05,
  //   },
  //   992: {
  //     slidesPerView: 6.05,
  //   },
  //   1200: {
  //     slidesPerView: 9.05,
  //   },
  // },
};
</script>
<style scoped lang="scss">
.write-about-us {
  @include point-md {
    display: grid;
    grid-template-columns: 200px minmax(0, 1fr);
    grid-column-gap: 4px;
  }
}
.write-about-us-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 125%;
  text-transform: uppercase;
  text-align: center;
  font-style: italic;
  background-color: var(--background-beige);
  padding: 12px 16px 8px 16px;
  margin-bottom: 0;
  @include point-md {
    font-size: 18px;
    padding: 20px 24px;
  }
  @include point-lg {
    text-align: start;
  }
}
.write-about-us-block {
  background-color: var(--background-beige);
  padding: 8px 16px 12px 16px;
  display: flex;
  align-items: center;
  //white-space: nowrap;
  @include point-md {
    padding: 20px 24px;
  }
  :deep(.def-slider__container) {
    margin-bottom: 0;
  }
  :deep(.def-slider) {
    max-width: 100%;
  }
  :deep(.swiper-container) {
    padding-left: 4px;
  }
  .swiper-slide {
    display: block;
    position: relative;
    padding: 0 16px;

    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    text-transform: uppercase;
    text-align: center;
    width: fit-content;
    text-wrap: nowrap;
    &:first-child:before {
      content: '';
      display: block;
      width: 6px;
      height: 6px;
      background-color: #d6c7b4;
      position: absolute;
      z-index: 1;
      left: 0;
      top: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
    }
    &:after {
      content: '';
      display: block;
      width: 6px;
      height: 6px;
      background-color: #d6c7b4;
      position: absolute;
      z-index: 1;
      right: 0;
      top: 50%;
      transform: translate(50%, -50%) rotate(45deg);
    }
  }
}
</style>
